<template>
  <main>
    <div class="l-main-content__inner">
      <div class="c-page-header">
        <h1 class="c-page-header-title">宿題管理</h1>
      </div>
      <div class="c-page-section">
        <a
          href="/teacher/homework/add/"
          class="c-button-white -homework -prefix-icon"
        ><span class="label">宿題を作成をする</span>
        </a>
      </div>
      <div class="p-homework-search-form">
        <info-toast
          :isOpen="isOpenInfoToast"
          :message="infoToastMessage"
          @close="closeInfoToast"
        ></info-toast>
      </div>
      <div class="p-homework-btn-list">
        <!-- 年度 -->
        <resettable-select-single
          v-if="academicYearsClassrooms"
          :options="academicYearsClassrooms.academicSessionIds"
          v-model:selected="academicSessionId"
          :init-label="true"
          :label-name="academicSessionLabel"
          :reset-option="true"
          @change="changeAcademicSessionId"
        ></resettable-select-single>

        <!-- 学年 -->
        <resettable-select-single
          v-if="academicYearsClassrooms"
          :options="academicYearsBelongCurrentAcademicSessionId"
          v-model:selected="academicYear"
          ref="academicYearsSelector"
          :init-label="true"
          :label-name="academicYearLabel"
          :reset-option="true"
          :is-disabled="!academicYearsBelongCurrentAcademicSessionId.length"
          @change="changeAcademicYear"
        ></resettable-select-single>

        <!-- 学級 -->
        <resettable-select-single
          v-if="academicYearsClassrooms"
          :options="classroomsBelongCurrentAcademicYear"
          v-model:selected="classroom"
          :init-label="true"
          :label-name="classroomLabel"
          :reset-option="true"
          :is-disabled="!classroomsBelongCurrentAcademicYear.length"
          @change="changeClassroom"
        ></resettable-select-single>

        <!-- 教科 -->
        <resettable-select-single
          :options="activeLicenseSubjects"
          v-model:selected="subject"
          :init-label="true"
          :label-name="subjectLabel"
          :reset-option="true"
          @change="changeSubject"
        ></resettable-select-single>

        <!-- 状態 -->
        <resettable-select-single
          v-if="academicYearsClassrooms"
          :options="homeworkStatusBelongCurrentAcademicYear"
          v-model:selected="homeworkStatus"
          :init-label="true"
          :label-name="homeworkStatusLabel"
          :reset-option="true"
          @change="changeHomeworkStatus"
        ></resettable-select-single>
      </div>
      <div
        v-if="hasHomeworkListItems"
        class="c-table-explain -right"
      >
        <copy-table-button :target-table="homeworkTableRef" />
      </div>
      <!-- sectionに.c-table-scroll-wrapをつけると、テーブル縦スクロールができる -->
      <section v-if="homeworkList">
        <div class="c-table-scroll">
          <div class="c-table-scroll__inner">
            <table
              ref="homeworkTableRef"
              class="c-table"
            >
              <thead>
                <tr>
                  <th>状態</th>
                  <th>
                    <div class="c-parts-tooltip-wrap">
                      完了数
                      <span class="c-parts-tooltip">説明
                        <span class="c-parts-tooltip__description">「完了した生徒数／合計生徒数」を表しています。<br>リンク先で各生徒の進捗を確認できます。<br>※完了した生徒数は、完了（期限内）と 完了（期限内） 両方を含みます。</span>
                      </span>
                    </div>
                  </th>
                  <th>学年</th>
                  <th>学級</th>
                  <th>教科</th>
                  <th>宿題タイトル</th>
                  <th>開始日</th>
                  <th>終了日</th>
                  <th>作成者</th>
                  <th data-copy-ignore>操作</th>
                </tr>
              </thead>
              <tbody v-if="hasHomeworkListItems">
                <tr
                  v-for="homework in homeworkList"
                  :key="homework.id"
                >
                  <td class="c-table-item-status">
                    <span
                      class="c-parts-homework-status"
                      :class="getHomeworkStatusColor(homework.status)"
                    >{{ homework.status }}</span>
                  </td>
                  <td class="u-text-no-break u-text-center">
                    <a
                      :href="`/teacher/homework/${homework.id}/progress/`"
                      class="c-parts-link"
                      target="_blank"
                    >{{ homework.completed_student_count }}/{{ homework.total_student_count }}<span class="c-table-item-small"> (人)</span></a>
                  </td>
                  <td class="u-text-center u-text-no-break">{{ homework.academic_year }}年</td>
                  <td class="c-table-item-class">{{ homework.classroom_name }}</td>
                  <td class="u-text-center u-text-no-break">{{ homework.subject_field_name }}</td>
                  <td>{{ homework.name }}</td>
                  <td class="u-text-center u-text-no-break">{{ homework.start_date }}</td>
                  <td class="u-text-center u-text-no-break">{{ homework.end_date }}</td>
                  <td><span class="u-text-ellipsis c-table-item-teacher">{{ homework.teacher_name }}</span></td>
                  <td class="c-table-item-operation">
                    <div class="c-parts-edit">
                      <a
                        :href="`/teacher/homework/${homework.id}/edit/`"
                        class="btnEdit"
                        aria-label="編集する"
                      ><span class="label">編集</span></a>
                      <a
                        v-if="canDelete(homework.status)"
                        href="javascript:void(0);"
                        @click="openDeleteModal(homework.id, getDeleteAlertText(homework.status))"
                        class="btnDelete"
                        aria-label="削除する"
                      ><span class="icon"></span></a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    v-if="existsCreatedHomework"
                    colspan="10"
                    class="c-table-no-data"
                  >該当の宿題はありません。</td>
                  <td
                    v-else
                    colspan="10"
                    class="c-table-no-data"
                  >宿題を作成すると宿題一覧が表示されます。</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <confirm-red-modal
      :isOpen="isOpenDeleteModal"
      okLabel="削除する"
      @ok="deleteHomework"
      @cancel="closeDeleteModal"
    >
      <template v-slot:text>この宿題を削除しますか？</template>
      <template v-slot:alertText>{{ deleteAlertText }}</template>
    </confirm-red-modal>
    <error-modal @close="closeErrorModal"></error-modal>
  </main>
</template>
<script setup lang="ts">
  import { ref, computed, onMounted } from "vue";
  import { HOMEWORK_STATUS, INFOTOAST_MESSAGE_PARAMNAME, LIST_HOMEWORK_SELECTBOX_LABEL_NAME, HOMEWORK_LIST_STATUS } from "@/consts/homework";
  import { useHomeworkStore } from "@/store/teacher/homework_store";
  import { useErrorStore } from "@/store/teacher/error_store";
  import { useWorkLicenseListStore } from "@/store/teacher/work_license_list_store";
  import { useLearningProgressStore } from "@/store/teacher/learning_progress_store";
  import { ISelectSingleOption } from "@/consts/interfaces";

  const homeworkTableRef = ref<HTMLTableElement | null>(null)

  type HomeworkStatus = typeof HOMEWORK_LIST_STATUS[number]['value'] | string
  interface IHomeworkListQueryParams {
    academic_session_id?: number | string;
    academic_year?: number | string;
    classroom_uuid?: string;
    subject_id?: number | string;
    status?: HomeworkStatus;
  }

  const errorStore = useErrorStore()
  const homeworkStore = useHomeworkStore()
  const workLicenseListStore = useWorkLicenseListStore()
  const learningProgressStore = useLearningProgressStore()

  const homeworkList = ref<Array<any> | null>(null)
  const existsCreatedHomework = ref(false)

  const idToDelete = ref(0)
  const isOpenDeleteModal = ref(false)
  const deleteAlertText = ref("")
  const deleteErrorCode = ref("")

  const isOpenInfoToast = ref(false)
  const infoToastMessage = ref("")

  const academicYearsClassrooms = ref(null);

  const academicSessionId =  ref<number | string >('');
  const academicYear = ref<number | string>('');
  const classroom = ref<string>('');
  const subject = ref<number | string>('');
  const homeworkStatus = ref<HomeworkStatus>('');

  const academicSessionLabel = LIST_HOMEWORK_SELECTBOX_LABEL_NAME.ACADEMIC_SESSION
  const academicYearLabel = LIST_HOMEWORK_SELECTBOX_LABEL_NAME.ACADEMIC_YEAR
  const classroomLabel = LIST_HOMEWORK_SELECTBOX_LABEL_NAME.CLASSROOM
  const subjectLabel = LIST_HOMEWORK_SELECTBOX_LABEL_NAME.SUBJECT
  const homeworkStatusLabel = LIST_HOMEWORK_SELECTBOX_LABEL_NAME.STATUS

  const hasHomeworkListItems = computed(() => !!homeworkList.value?.length)

  // 学年一覧
  const academicYearsBelongCurrentAcademicSessionId = computed(() => {
    if (academicYearsClassrooms.value && academicSessionId.value) {
      return academicYearsClassrooms.value.academicYears[academicSessionId.value] || [];
    }
    return [];
  })

  // 学級一覧
  const classroomsBelongCurrentAcademicYear = computed(() => {
    if (academicYearsClassrooms.value && academicSessionId.value && academicYear.value) {
        return academicYearsClassrooms.value.classrooms[academicSessionId.value][academicYear.value] || [];
    }
    return [];
  })

  // 教科一覧
  const activeLicenseSubjects = computed((): ISelectSingleOption[] => {

    if (!workLicenseListStore.workLicenseList) {
      return [];
    }
    // 有効な教材ライセンスかつライセンスを持っている生徒がいる教科のみをセレクトボックスに表示する
    // 教科に重複があった場合に重複を削除し、教科IDの昇順に並び替える
    const subjects = new Map(
      workLicenseListStore.workLicenseList.activeLicense
        .filter((license) => parseInt(license.usedStatus) > 0)
        .map((license) => [license.subjectId, {value: license.subjectId, name: license.subjectName}])
    );
    return Array.from(subjects.values()).sort((a, b) => a.value - b.value);
  })

  // 宿題の状態一覧
  const homeworkStatusBelongCurrentAcademicYear = computed(() => {
    return HOMEWORK_LIST_STATUS
  })

  onMounted(async() => {
    // プルダウンに表示する年度・学年・学級の値を取得
    await searchInitialDataFromSearchParams();
    await fetchHomeworkListWithQueryParams();
    // 宿題を1度も作ったことがない時と絞り込んだ結果がない時の文言のだしわけに使う
    if (homeworkList.value.length > 0) {
      existsCreatedHomework.value = true
    }
    showInfoToastFromQueryParams()
  })

  function showInfoToastFromQueryParams() {
    const url = new URL(window.location.toString())
    const params = url.searchParams

    if (params.has(INFOTOAST_MESSAGE_PARAMNAME)) {
      const message = params.get(INFOTOAST_MESSAGE_PARAMNAME)
      window.history.replaceState(null, "", url.pathname)
      openInfoToast(message)
    }
  }

  function getHomeworkStatusColor(status: string): string {
    // 宿題の状態に応じたCSSクラス名を返す
    switch (status) {
      case HOMEWORK_STATUS.UNPUBLISHED:
        return "-unpublished"
      case HOMEWORK_STATUS.PUBLISHED:
        return "-release"
      case HOMEWORK_STATUS.CLOSED:
        return "-end"
      default:
        return ""
    }
  }

  function canDelete(status: string) {
    return [HOMEWORK_STATUS.UNPUBLISHED, HOMEWORK_STATUS.PUBLISHED].includes(status)
  }

  function getDeleteAlertText(status: string): string {
    // 宿題の状態に応じた削除警告テキストを返す
    switch (status) {
      case HOMEWORK_STATUS.UNPUBLISHED:
        return "この操作は取消できません。本当に削除しますか？"
      case HOMEWORK_STATUS.PUBLISHED:
        return "この宿題は既に生徒に公開されています。本当に削除しますか？"
      default:
        return ""
    }
  }

  function openDeleteModal(id: number, alertText: string) {
    idToDelete.value = id
    deleteAlertText.value = alertText
    isOpenDeleteModal.value = true
  }

  function closeDeleteModal() {
    isOpenDeleteModal.value = false
    idToDelete.value = 0
  }

  async function deleteHomework() {
    const success  = await homeworkStore.fetchHomeworkDelete(idToDelete.value)
    closeDeleteModal()

    if (success) {
      openInfoToast(success.message)

      // 宿題一覧をrefresh
      await fetchHomeworkListWithQueryParams()       
    } else {
      // エラーでも、コードE001の場合のみ宿題一覧をrefreshしたいため、エラーコードを保持
      deleteErrorCode.value = errorStore.getTeacherError?.code
    }
  }

  async function closeErrorModal() {
    if (deleteErrorCode.value === "E001") {
      // 宿題一覧画面をrefresh
      window.location.reload()
    }
    deleteErrorCode.value = ""
  }

  function openInfoToast(message: string) {
    isOpenInfoToast.value = true
    infoToastMessage.value = message
  }

  function closeInfoToast() {
    isOpenInfoToast.value = false
    infoToastMessage.value = ""
  }

  function getHomeworkListQueryParams() {
    let params: IHomeworkListQueryParams = {}

    // クエリパラメータに年度IDだけ指定がある場合
    if (academicSessionId.value) { params.academic_session_id = academicSessionId.value }

    // クエリパラメータに学年まで指定がある場合
    if (academicSessionId.value && academicYear.value) { params.academic_year = academicYear.value }

    // クエリパラメータに学級まで指定がある場合
    if (academicSessionId.value && academicYear.value && classroom.value) { params.classroom_uuid = classroom.value }

    // 教科に指定がある場合
    if (subject.value) { params.subject_id = subject.value }
          
    // 宿題の状態に指定がある場合
    if (homeworkStatus.value) { params.status = homeworkStatus.value }

    return params
  }

  // 年度セレクトボックス操作時
  async function changeAcademicSessionId() {
    academicYear.value = '';
    classroom.value = '';

    await fetchHomeworkListWithQueryParams();
  }

  // 学年セレクトボックス操作時
  async function changeAcademicYear() {
    classroom.value = '';

    await fetchHomeworkListWithQueryParams();
  }

  // 学級セレクトボックス変更時
  async function changeClassroom() {
    await fetchHomeworkListWithQueryParams();
  }

  // 教科セレクトボックス変更時
  async function changeSubject() {
    homeworkList.value  = await homeworkStore.fetchHomeworkList(getHomeworkListQueryParams());
  }

  // 宿題の状態セレクトボックス変更時
  async function changeHomeworkStatus() {
    await fetchHomeworkListWithQueryParams();
  }

  // クエリパラメーターで絞られた宿題一覧を取得する
  async function fetchHomeworkListWithQueryParams() {
    homeworkList.value = await homeworkStore.fetchHomeworkList(getHomeworkListQueryParams());
  }

  // プルダウンに表示する値を取得
  async function searchInitialDataFromSearchParams() {
    // 学年・学級一覧を取得
    academicYearsClassrooms.value = await learningProgressStore.fetchYearClass();
    // 学級を持っている場合は年度IDの初期値（当年度）を設定し、そうでなければnullにする（「年度」を出す）
    academicSessionId.value = academicYearsClassrooms.value.academicSessionIds.find(academicSessionId => academicSessionId.value === academicYearsClassrooms.value.defaultAcademicSessionId) ? academicYearsClassrooms.value.defaultAcademicSessionId : '';
    // 教科セレクトボックスに表示する教科を取得する
    workLicenseListStore.fetchListWorkLicense();
  }
</script>
